import Nullstack from 'nullstack';
export default function IconBrandNordVpn({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-brand-nord-vpn",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M9.992 15l-2.007 -3l-4.015 8c-2.212 -3.061 -2.625 -7.098 -.915 -10.463a10.14 10.14 0 0 1 8.945 -5.537a10.14 10.14 0 0 1 8.945 5.537c1.71 3.365 1.297 7.402 -.915 10.463l-4.517 -8l-1.505 1.5"
  }), "   ", Nullstack.element("path", {
    d: "M14.5 15l-3 -6l-2.5 4.5"
  }), " ");
}